import { DialogTitleProps, makeStyles, withStyles } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/ClearOutlined'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  styled,
  Typography,
  useComponentVersion,
} from 'opensolar-ui'

//TODO: should be moved at some point to /elements

export const StyledDialog = withStyles({
  paper: {
    width: 'auto',
  },
})(Dialog)

export const StyledDialog3 = withStyles({
  paper: {
    width: 800,
  },
})(Dialog)

export const StyledDialogContent = withStyles({
  root: {
    padding: '20px !important',
    maxHeight: 'calc(100vh - 200px)',
  },
})(DialogContent)

export const StyledDialogActions = withStyles({
  root: {},
})(DialogActions)

const useTitleStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    color: 'rgba(0, 0, 0, 0.87)',
  },
}))

const StyledDialogTitleWrapper = styled(DialogTitle)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
})

type TitleProps = DialogTitleProps & {
  onClose?: () => void
}

export const StyledDialogTitle = (props: TitleProps) => {
  const version = useComponentVersion('dialog')
  const classes = useTitleStyles()
  const { children, onClose, ...other } = props
  return (
    <StyledDialogTitleWrapper disableTypography className={classes.root} {...other}>
      <div>{version && version > 1 ? children : <Typography textVariant="h5">{children}</Typography>}</div>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </StyledDialogTitleWrapper>
  )
}
